import script from "./welcomeAll.vue?vue&type=script&setup=true&lang=js"
export * from "./welcomeAll.vue?vue&type=script&setup=true&lang=js"

import "./welcomeAll.vue?vue&type=style&index=0&id=7fa9acdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa9acdb"]])

export default __exports__